module.exports = __webpack_public_path__ + "img/no_order_pc.3de06cd.png";